<template>
  <v-card class="pa-4">
    <v-flex xs12 pb-4 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-flex xs12 pb-4 v-if="success">
      <v-alert :value="true" type="success">{{success}}</v-alert>
    </v-flex>
    <p>{{$lang.labels.confirmationText}}</p>
    <v-layout row wrap justify-space-between>
      <v-btn flat @click="$emit('close')" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn :disabled="posting" color="primary" @click="deactivate()" class="mx-0">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['data'],
    data: () => ({
      err: '',
      success: '',
      posting: false,
    }),
    methods: {
      deactivate() {
        this.posting = true;
        this.$http.post(`${this.data.url}/deactivate/${this.data.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = res.body.statusText;
              setTimeout(() => { this.$emit('close'); this.$emit('change', this.data.id); this.posting = true; }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.posting = false;
            this.err = err.body.statusText || err.body.message;
          });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// DeactivationModal.vue?9194139c